import { isRecord } from '@/predicates/commonTypes'

export interface StatusOK {
  status: 'ok'
}

export interface StatusError {
  error: {
    code: number
    reason: string
    message: string
  }
}

export interface ErrorResponse {
  error: string
  code: string
}

export const isErrorResponse = (value: unknown): value is ErrorResponse => {
  return isRecord(value) &&
    typeof value.error === 'string' &&
    typeof value.code === 'string'
}

export const isStatusError = (value: unknown): value is StatusError => {
  return isRecord(value) &&
    'error' in value &&
    typeof value.error === 'object' &&
    'code' in value.error &&
    'reason' in value.error &&
    'message' in value.error
}

